import { VmImagesView } from "@/admin/vm/VmImagesView.tsx";
import { createLazyFileRoute } from "@tanstack/react-router";

export const Route = createLazyFileRoute("/admin/_menu/_simple/vm_images")({
    component: VmImagesView,
});
